import { motion } from 'framer-motion';

interface ChipStackProps {
  amount: number;
  animateToPot?: boolean;
}

function chipColor(amount: number): string {
  if (amount >= 1000) return 'from-purple-400 to-purple-700 border-purple-200/60';
  if (amount >= 500) return 'from-ink-700 to-ink-900 border-white/30';
  if (amount >= 100) return 'from-emerald-400 to-emerald-700 border-emerald-100/60';
  if (amount >= 25) return 'from-rose-400 to-rose-700 border-rose-100/60';
  return 'from-gold-400 to-gold-600 border-gold-100/60';
}

export function ChipStack({ amount, animateToPot }: ChipStackProps) {
  if (amount <= 0) return null;
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={animateToPot ? { opacity: [1, 1, 0.2], y: [0, 0, -30], scale: [1, 1, 0.6] } : { opacity: 1, scale: 1 }}
      transition={{ duration: animateToPot ? 0.6 : 0.25 }}
      className="flex items-center gap-1"
    >
      <div className={`w-5 h-5 rounded-full bg-gradient-to-br ${chipColor(amount)} border shadow-card`} />
      <span className="text-[11px] font-semibold text-gold-400 tabular-nums">{amount.toLocaleString('ru-RU')}</span>
    </motion.div>
  );
}
